<template>
  <div id="tabbar">
    <router-link
      v-for="(item, index) in items"
      :to="item.path"
      :key="index"
      v-on:click="onClick(index)"
    >
      <div id="tab">
        <div :id="index == 2 ? 'main_title' : 'title'">{{ item.title }}</div>
        <hr id="line" v-show="this.$route.path.includes(item.path)" />
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "TabBar",
  props: {
    list: Array,
  },
  data() {
    return {
      selectedIndex: 2,
      items: [
        {
          path: "/introduce",
          title: "简介",
        },
        {
          path: "/guinong",
          title: "主张",
        },
        {
          path: "/home",
          title: "首页",
        },
        {
          path: "/mallApp",
          title: "下载",
        },
      ],
    };
  },
  methods: {
    onClick(index) {
      this.selectedIndex = index;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#tabbar {
  padding: 0pt calc(40/1080 * 100vw) 0vw calc(40/1080 * 100vw);
  height: calc(120/1080 * 100vw);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: center;
  background-color: #ffffff;
}

#tab {
  height: calc(120/1080 * 100vw);
  display: flex;
  flex-direction: column;
}

#title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(130/1080 * 100vw);
  height: calc(72/1080 * 100vw);
  color: #333333;
  font-size: calc(34/1080 * 100vw);;
  font-weight: bold;
  margin-top: calc(24/1080 * 100vw);
}

#main_title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(130/1080 * 100vw);
  height: calc(72/1080 * 100vw);
  color: #ffffff;
  background-color: #000000;
  border-radius: calc(8/1080 * 100vw);
  font-size: calc(34/1080 * 100vw);
  font-weight: bold;
  margin-top: calc(24/1080 * 100vw);
}

#line {
  width: 100%;
  height: calc(10/1080 * 100vw);;
  background-color: #000000;
  margin: calc(14/1080 * 100vw) 0vw 0vw 0vw;
  padding: 0vw;
}

a {
  text-decoration: none;
}
</style>